
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/privacy-policy",
      function () {
        return require("private-next-pages/info/privacy-policy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/privacy-policy"])
      });
    }
  